import { BaseModel } from "sjs-base-model";
import AddressModel from "./AddressModel";

export default class UserDetailsModel extends BaseModel {
    id = "";
    email = "";
    additionalEmail2 = "";
    additionalEmail2Verified = false;
    additionalEmail3 = "";
    additionalEmail3Verified = false;
    firstName = "";
    lastName = "";
    jobPosition = "";
    createdOn = "";
    accountActivated = false;
    userLocked = false;
    privacyNoticeAgreed = false;
    phone = "";
    mobilePhone = "";
    billingAddress = new AddressModel();
    deliveryAddress = new AddressModel();
    company = "";
    tin = "";
    organization = "";
    username = "";
    bpId = 0;
    bpName = "";
    isDeletable = false;
    
    constructor(data) {
        super();
        this.update(data);
    }
}
